import type { ComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdResponse } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentRiskAssessmentResultsByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentRiskAssessmentResultsByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOversightAssessmentRiskAssessmentResultsByRiskIdArgs = {
  riskId: string;
};

export const useGetOversightAssessmentRiskAssessmentResultsByRiskId =
  createQueryHook<
    UseGetOversightAssessmentRiskAssessmentResultsByRiskIdArgs,
    ComplianceMonitoringAssessmentRiskAssessmentResultsByRiskIdResponse,
    GetOversightAssessmentRiskAssessmentResultsByRiskIdQuery
  >({
    trpcQueryOptions: (trpc, { riskId }) =>
      trpc.frontend.assessment.complianceMonitoringAssessmentRiskAssessmentResultsByRiskId.queryOptions(
        {
          riskId,
        }
      ),
    mapTrpcDataToGraphQL: (data) =>
      ({
        risk_controlled_oversight_result:
          data.risk_controlled_second_line_result,
        risk_uncontrolled_oversight_result:
          data.risk_uncontrolled_second_line_result,
      }) as unknown as GetOversightAssessmentRiskAssessmentResultsByRiskIdQuery,
    graphqlDocument:
      GetOversightAssessmentRiskAssessmentResultsByRiskIdDocument,
    graphqlVariables: ({ riskId }) => ({ RiskId: riskId }),
  });
